import * as React from 'react'
import cx from 'classnames'
import { ContentLabel } from 'components/ContentLabel'
import styles from './FormSection.sass'

interface FormSectionProps {
  edgeToEdge?: boolean
  children?: React.ReactNode
  /**
   * If this is a `String`, will wrap in a <ContentLabel>. Otherwise renders as-is.
   */
  label?: React.ReactNode
}

export default function FormSection({
  children,
  edgeToEdge,
  label,
}: FormSectionProps) {
  return (
    <div className={cx(styles.root, edgeToEdge && styles.edgeToEdge)}>
      <div className={styles.label}>
        {typeof label === 'string' ? (
          <ContentLabel>{label}</ContentLabel>
        ) : (
          label
        )}
      </div>

      <div className={styles.box}>{children}</div>
    </div>
  )
}
